































import Vue from "vue";
import { Watch } from "vue-property-decorator";
import { Component } from "vue-property-decorator";
import FilterComponent from "./Filter/Filter.vue";
import ApplicationListComponent from "./ApplicationList.vue";
import ApplicationTableComponent from "./ApplicationTableList.vue";
import { http } from "@/shared/https";
import { Utilities as utils } from "@/shared/utilities";
import "@/styles/iucn/filter.css";
import "@/styles/iucn/main-content.css";
import { Workspace } from "@/entities";
import AdvanceSearchComponent from "@/components/common/AdvanceFilter/AdvanceSearch.vue";
import { ReportFilter, ReportParameter } from "@/entities";
import { Locales } from "@/i18n/locales";

const namespace: string = "application";

@Component({
  components: {
    FilterComponent,
    ApplicationListComponent,
    ApplicationTableComponent,
    AdvanceSearchComponent,
  },
})
export default class ApplicationLayoutComponent extends Vue {
  isTabView: boolean = false;
  collapsed = false;
  items: Array<any> = [];
  uploadReady: boolean = true;
  selectedParams: Array<ReportParameter> = [];
  filters: Array<any> = [];
  advancefilters: Array<any> = [];
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  tabs = [
    {
      component: "ApplicationListComponent",
      text: "Grid View",
      icon: "mdi-format-list-bulleted-square",
    },
    {
      component: "ApplicationTableComponent",
      text: "Card View",
      icon: "mdi-view-grid",
    },
  ];
  currentTab: any = this.tabs[0];

  get currentTabComponent() {
    return this.currentTab.component;
  }

  collapseFilter() {
    this.collapsed = !this.collapsed;
  }

  switchLayout(isTabView) {
    this.isTabView = !isTabView;

    if (this.isTabView) {
      this.currentTab = this.tabs[1];
    } else {
      this.currentTab = this.tabs[0];
    }
  }

  itemsMapper(items) {
    if (items && items.length > 0) {
      return items.map((x) => {
        x.ProjectBudget = x.TotalProjectBudget
          ? utils.formatCurrency(x.TotalProjectBudget, x.BudgetCurrency, this.defaultLocale)
          : "";

        if (x.RequestedAmount) {
          x.ProjectBudget = `${x.ProjectBudget} (${utils.formatCurrency(
            x.RequestedAmount,
            x.BudgetCurrency,
            this.defaultLocale
          )})`;
        }

        return x;
      });
    }
  }

  getFilters() {
    http.get(`api/AdminDashboard/Application/GetFilter`).then((resp: any) => {
      if (resp.status >= 200 && resp.status < 300) {
        this.filters = resp.data.Result;
      }
    })
  }

  getAdvanceFilters() {
    http.get(`api/AdminDashboard/AdvanceFilter`).then((resp: any) => {
      if (resp.status >= 200 && resp.status < 300 && resp.data) {
        this.advancefilters = resp.data;
      }
    });
  }

  onSearch() {
    var filterType = "application";
    http
      .post(`api/AdminDashboard/Filter/${filterType}`, this.selectedParams)
      .then((resp: any) => {
        if (resp.status >= 200 && resp.status < 300) {
          this.items = this.itemsMapper(resp.data.Items) || [];
        }
      });
  }

  /*callProposalCallFilter*/
  callProposalCallFilter(e) {
    let filteredData = '';
    var self = this;
    http.get(`/api/AdminDashboard/application?${e}`).then((resp: any) => {
      this.uploadReady = false;
      this.$nextTick(() => {
        this.uploadReady = true;
      });
      self.items = this.itemsMapper(resp.data.Items);
      if(resp.data.Filters != null){
        filteredData = JSON.stringify(resp.data.Filters);
      }      
      let initialFilter = JSON.stringify(self.filters);
      if(filteredData && filteredData !== initialFilter){
        self.filters = resp.data.Filters;
      }
    });
  }

  mounted() {
    var self = this;

    this.getFilters();
    self.getAdvanceFilters();

    this.listProposal().then((resp: any) => {
      self.items = this.itemsMapper(resp);      
    });
  }

  listProposal() {
    let localData = localStorage.getItem('filterBy');
    if(localData == "{}")
    {
      return http
        .get(`/api/AdminDashboard/application?StatusId=0`)
        .then((resp: any) => {
          return resp.data.Items;          
        });
    }
    else
    {
      var newFilterData = "";
      var filterLst = JSON.parse(localData);
      Object.entries(filterLst).forEach(([key, value]) => {       
        newFilterData = newFilterData == "" ? key + "=" + value : (newFilterData + "&" + key + "=" + value);       
      });    

      return http
      .get(`/api/AdminDashboard/application?${newFilterData}`)
      .then((resp: any) => {
        return resp.data.Items;        
      });
    }
  }
}
